import { render, staticRenderFns } from "./Traditional.vue?vue&type=template&id=251bdf4e&scoped=true"
import script from "./Traditional.vue?vue&type=script&lang=js"
export * from "./Traditional.vue?vue&type=script&lang=js"
import style0 from "./Traditional.vue?vue&type=style&index=0&id=251bdf4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251bdf4e",
  null
  
)

export default component.exports